import { Id, Order, Paging } from '../../../common'
import { ROTransaction, RWTransaction } from '../../../db'

export interface EntityAddress {
  id: number
  entityId: Id
  fieldsToIndex?: string[]
  indexedAt?: Date
  updatedAt: Date
}

export interface SaveEntityAddress {
  entityId: Id
  fieldsToIndex?: string[]
  indexedAt?: Date
  updatedAt: Date
}

export type AddEntityAddressOpts = {
  entityId: Id
  fieldsToIndex?: string[]
  indexedAt?: Date
  updatedAt: Date
}

export type UpdateEntityAddressOpts = {
  fieldsToIndex?: string[]
  indexedAt?: Date
  updatedAt?: Date
}

export enum EntityAddressOrderFields {
  UPDATED_AT = 'updatedAt',
}

export interface EntityAddressFilter {
  ids?: number[]
  entityIds?: Id[]
  notIndexedOnly?: boolean
  // updatedAt?: Date
}

export interface EntityAddressFindOptions {
  filter?: EntityAddressFilter
  order?: Order<EntityAddressOrderFields> | undefined
  paging?: Paging
}

export interface EntityAddressesRepository {
  findAll(tx: ROTransaction, opts?: EntityAddressFindOptions): Promise<EntityAddress[]>
  count(tx: ROTransaction, filter?: EntityAddressFilter): Promise<number>
  save(tx: RWTransaction, entityAddress: SaveEntityAddress): Promise<EntityAddress>
  delete(tx: RWTransaction, id: number): Promise<void>
}

export function normalizeEA(ea?: EntityAddress): Partial<EntityAddress | void> {
  if (!ea) return

  return {
    entityId: ea.entityId,
    indexedAt: ea.indexedAt,
    updatedAt: ea.updatedAt,
    fieldsToIndex: ea.fieldsToIndex,
  }
}
